
define('jst!tooltips/_hotkey',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<%=title%><span class="hotkey"><%=data.hotkey%></span>');
 });

